import { render } from "./FlashPage.vue?vue&type=template&id=576d5fb4"
import script from "./FlashPage.vue?vue&type=script&lang=js"
export * from "./FlashPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/Desktop/DBCapacity-VUE/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__